'use strict';

var Hounisen = Hounisen || {};

Hounisen.product = new function () {

    function init() {
        // Init functions
        appendBreadcrumb();
        input();
        addToFavoriteList();
    }

    function appendBreadcrumb() {
        var isProductPage = $('.row.product').length > 0;
        var breadcrumb = $('.breadcrumb');
        if (isProductPage) {
            var url = "https://www.hounisen.com" + window.location.pathname;
            var productName = $('h1.page-header__title').text();
            var position = breadcrumb.children().length;

            breadcrumb.append("<li class=\"breadcrumb__item\" itemprop=\"itemListElement\" itemscope=\"\" itemtype=\"http://schema.org/ListItem\"><span itemprop=\"item\"><meta itemprop=\"id\" content=\"" + url + "\" /><span itemprop=\"name\">" + productName + "</span></span><meta itemprop=\"position\" content=\"" + (position + 1) + "\" /></li>")
        }
        breadcrumb.find('li:last-child a').attr("href", "javascript:void(0);");
    }

    function addToFavoriteList() {

        $(document).on('click', '.popup-show', function() {
            $(this)
                .siblings($('#' + $(this).data('popup')))
                .show("fast");
        });


        $(document).on('click', '.popup-form .close', function() {
            $(this)
                .parent()
                .hide("fast");
        });
    }

    function updateQueryStringParameter(key, value) {
        var url = new URL(window.location.href);
        var params = new URLSearchParams(url.search);

        params.delete(key);

        if (!(key == 'ListView' && value == 'list')) {
            params.set(key, value);
        }

        if (params.has('SortBy') && params.has('ListView')) {
            var sortByValue = params.get('SortBy');
            var listViewValue = params.get('ListView');

            params.delete('SortBy');
            params.delete('ListView');

            params.set('SortBy', sortByValue);
            params.set('ListView', listViewValue);
        }

        // Update the URL with the modified parameters
        url.search = params.toString();
        window.history.replaceState({}, '', url);
        window.location.reload();
    }

    function sortProductsBy(sortcode) {
        document.cookie = "sortby=" + sortcode;
        updateQueryStringParameter('SortBy', sortcode);
    }

    function listProductsByView(view) {
        updateQueryStringParameter('ListView', view);
    }

    function input() {

        // This button will increment the value
        function checkInput(e) {
            var currentVal = parseInt($(this).val());
            var addtocartInput = $(this).parent('.js-addtocart-input');
            var $unitOptionSelected = addtocartInput.find('.unit option:selected');
            var minOrder = parseInt($unitOptionSelected.data('min-order'));
            if (!isNaN(currentVal) && currentVal < minOrder) {
                $(this).val(minOrder);
            }
        }


        // This button will decrement the value till 0
        $(document).on(
            'click',
            '.product__quantity-button--minus, .product-list-item__quantity-button--minus, .favoritelist-product__quantity-button--minus',
            function(e) {

                e.preventDefault();
                var fieldName = $(this).attr('field');
                var field = $(this).next($('input[data-name=' + fieldName + ']'));
                var currentVal = parseInt(field.val());
                var addtocartInput = $(this).parent().parent().parent().next();
                var $unitOptionSelected = addtocartInput.find('input[name="UnitID"]:checked');
                var lotSize = 1;
                var minOrder = 1;
                if ($unitOptionSelected.length) {
                    lotSize = parseInt($unitOptionSelected.data('lot-size'));
                    minOrder = parseInt($unitOptionSelected.data('min-order'));
                }
                if (!isNaN(currentVal) && currentVal > minOrder) {
                    var newVal = currentVal - lotSize;
                    field.val(newVal);
                } else {
                    field.val(minOrder);
                }
            }
        );
        // This button will increment the value
        $(document).on(
            'click',
            '.product__quantity-button--plus, .product-list-item__quantity-button--plus, .favoritelist-product__quantity-button--plus',
            function (e) {

                e.preventDefault();
                var fieldName = $(this).attr('field');
                var field = $(this).is($('input[data-name=' + fieldName + ']')) ? $(this) : $(this).prev($('input[data-name=' + fieldName + ']'));
                var currentVal = parseInt(field.val());
                var addtocartInput = $(this).parent().parent().parent().next();
                var $unitOptionSelected = addtocartInput.find('input[name="UnitID"]:checked');
                var lotSize = 1;
                var minOrder = 1;
                if ($unitOptionSelected.length) {
                    lotSize = parseInt($unitOptionSelected.data('lot-size'));
                    minOrder = parseInt($unitOptionSelected.data('min-order'));
                }
                if (!isNaN(currentVal) && currentVal >= minOrder) {
                    var newVal = currentVal + lotSize;
                    field.val(newVal);
                } else {
                    field.val(minOrder);
                }


            }
        );


        $(".product__description__long br").remove()
        //var stringToTrim = $(".product__description__long");
        //stringToTrim.each(function () {
        //    var str = $(this).text();

        //    if (str.includes("...")) {
        //        var indexOF = str.indexOf("...");
        //        var laststr = str.substring(0, indexOF) + "...";
        //        this.innerHTML = laststr;
        //    }
        //})
        // Update price on enter click
        $('.product__quantity-input, .product-list-item__quantity-input, .favoritelist-product__quantity-input').keypress(function (e) {
            var key = e.which;
            if (key == 13) {
                $('.product__quantity-input, .product-list-item__quantity-input').trigger('blur');
            }
        });

        $('.product__quantity-input, .product-list-item__quantity-input, .favoritelist-product__quantity-input').blur(checkInput);

        $('.product__addtocart-input .unit, .product-list-item__addtocart-input .unit').change(function (e) {
            var value = parseInt($(this).find(':selected').data('min-order'));
            $(this).prev().prev().val(value);
        });
    }

    return {
        init: init,
        sortProductsBy: sortProductsBy,
        listProductsByView: listProductsByView
    };
};
$(document).ready(function () {
    $("#js-smooth-scroll").on("click", function (e) {
        var int;
        if (document.getElementById("navOne").classList.contains("affix-top")) {
            int = 100;
        } else {
            int = 50;
        }
        e.preventDefault();
        $('html, body').animate(
            {
                scrollTop: $("#productLongDescriptionID").offset().top - int,
            },
            500,
            'linear'
        )
    })
})

//document.addEventListener("DOMContentLoaded", function () {
//    var scrollBtn = document.getElementById('js-smooth-scroll');
//    var scrollToMe = document.getElementById('productLongDescriptionID');
//    var parent = document.querySelector('div.row.product');

//    var parentHeight;
//    scrollBtn.addEventListener('click', function (e) {
//        e.preventDefault();
//        parentHeight = parent.clientHeight - checkWidth();
//        scrollToMe.scrollIntoView({ block: " nearest", inline: "nearest" });
//       /* window.scrollBy(0, parentHeight);*/

//    });
//});
//function checkWidth() {
//    var int;
//    if (window.innerWidth < 1200 && window.innerWidth > 990) {
//        if (!document.getElementById("navOne").classList.contains("affix-top")) {

//            int = 70;
//        } else {
//            int = 50;
//        }
//    }
    //else if (window.innerWidth < 991 && window.innerWidth > 767) {
    //    if (!document.getElementById("navOne").classList.contains("affix-top")) {

    //        int = 100;
    //    } else {
    //        int = 100;
    //    }
    //}
    //else if (window.innerWidth <= 767 && window.innerWidth > 640) {
    //    int = 70;

    //} else {
    //    if (!document.getElementById("navOne").classList.contains("affix-top")) {

    //        int = 70;
    //    } else {
    //        int = 130;
    //    }
    //}
//    return int;

//}
